import {validators} from 'vue-form-generator';

export const shippingMethod = {
    type: 'radios',
    label: '',
    id: 'shipping-method',
    model: 'shippingMethod',
    values: [],
    required: true,
    visible: true,
    disabled: false,
    styleClasses: "col xs-12 md-6 shipping-method",
    hideNoneSelectedText: true,
    validator: [validators.string],
}
